'use strict';
import axios from 'axios';

import { 
  defaultRequestTransformer,
  defaultResponseTransformer
} from '../transformers/index.js';

import { 
  defaultRequestInterceptor, 
  defaultResponseInterceptor,
  defaultErrorInterceptor 
} from '../interceptors/index.js';

const defaultOpts = {
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json'
  }
};

/**
 * @description Base HTTPClient builder
 * @abstract
 */
class HTTPClientBase {
  constructor({ opts } = {}) {
    if (this.constructor === HTTPClientBase) {
      throw new TypeError(`Abstract class ${this.constructor.name} cannot be instantiated directly`);
    }
    this._client = axios.create(opts || defaultOpts);

  }

  intercepts ({ request, response, error } = {}) {
    this._client.interceptors.request.use(request || defaultRequestInterceptor);
    this._client.interceptors.response.use(response || defaultResponseInterceptor, error || defaultErrorInterceptor);

    // return `this` to allow method-chaining
    return this;
  }
  
  transforms ({ request, response } = {}) {
    // this._client.defaults.transformRequest = request || defaultRequestTransformer;
    this._client.defaults.transformResponse = response || defaultResponseTransformer;

    return this;
  }

}

export default HTTPClientBase;